import { cn } from '@/lib/utils'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

export interface ButtonTabsProps extends React.ComponentProps<typeof Tabs> {
  tabs: {
    label: string
    value: string
    content: React.ReactNode
  }[]
  listClassName?: string
  triggerClassName?: string
  contentClassName?: string
}

function ButtonTabs({
  tabs,
  listClassName,
  triggerClassName,
  contentClassName,
  ...props
}: ButtonTabsProps) {
  return (
    <Tabs {...props}>
      <TabsList
        className={cn(
          'border-border text-foreground h-auto w-full justify-start gap-6 rounded-none border-b bg-transparent px-0 py-1',
          listClassName
        )}
      >
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className={cn(
              'hover:text-foreground data-[state=active]:after:bg-primary relative !flex-none !px-0 after:absolute after:inset-x-0 after:bottom-0 after:-mb-1 after:h-0.5 data-[state=active]:bg-transparent data-[state=active]:shadow-none',
              triggerClassName
            )}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>

      {tabs.map((tab) => (
        <TabsContent
          key={tab.value}
          value={tab.value}
          className={cn(contentClassName)}
        >
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  )
}

export { ButtonTabs }
